import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { VoiceSettings } from '@/types';
import { TTS_CONFIG } from '@/constants';

interface VoiceSettingsState extends VoiceSettings {
  setVoice: (index: number) => void;
  setRate: (rate: number) => void;
  setPitch: (pitch: number) => void;
  setVolume: (volume: number) => void;
  resetToDefaults: () => void;
}

const defaultSettings: VoiceSettings = {
  selectedVoiceIndex: -1, // -1 means use default/preferred
  rate: TTS_CONFIG.DEFAULT_RATE,
  pitch: TTS_CONFIG.DEFAULT_PITCH,
  volume: TTS_CONFIG.DEFAULT_VOLUME,
};

export const useVoiceSettingsStore = create<VoiceSettingsState>()(
  persist(
    (set) => ({
      ...defaultSettings,
      setVoice: (index) => set({ selectedVoiceIndex: index }),
      setRate: (rate) => set({ rate }),
      setPitch: (pitch) => set({ pitch }),
      setVolume: (volume) => set({ volume }),
      resetToDefaults: () => set(defaultSettings),
    }),
    {
      name: 'voice-settings-storage',
    }
  )
);
